import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    if (menuOpen) {
      const closeMenu = () => setMenuOpen(false);
      document.addEventListener('click', closeMenu);
      return () => document.removeEventListener('click', closeMenu);
    }
  }, [menuOpen]);

  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          <Link to="/" className="logo">
            <img src="/img/square_screenshots/logo.png" alt="GTO Preflop Logo" />
          </Link>
          
          {isMobile && (
            <div className="mobile-nav-wrapper">
              {/* Download button always visible */}
              <a 
                href="https://apps.apple.com/us/app/gto-preflop/id1629141961" 
                className="download-btn ios-nav-btn"
                target="_blank" 
                rel="noopener noreferrer"
              >
                Download
              </a>

              {/* Hamburger icon */}
              <div 
                className={`hamburger-menu ${menuOpen ? 'active' : ''}`} 
                onClick={toggleMenu}
                role="button"
                tabIndex={0}
                aria-label="Toggle navigation menu"
                aria-expanded={menuOpen}
                aria-controls="mobileNavMenu"
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
          
          <ul id="mobileNavMenu" className={`nav-links ${menuOpen ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}>
            <li><Link to="/marketing" onClick={() => setMenuOpen(false)}>About</Link></li>
            <li><Link to="/support" onClick={() => setMenuOpen(false)}>Support</Link></li>
            <li><Link to="/affiliate" onClick={() => setMenuOpen(false)}>Affiliate Program</Link></li>
            
            {/* Download button only in the regular nav when not mobile */}
            {!isMobile && (
              <>
                <li>
                  <a 
                    href="https://apps.apple.com/us/app/gto-preflop/id1629141961" 
                    className="download-btn ios-nav-btn"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                </li>
                <li>
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.gtopreflopfree.gtopreflopfree" 
                    className="download-btn android-nav-btn" 
                    style={{ display: 'none' }} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header; 